function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#036363",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 5.1898241,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "markers stroke fill"
    },
    d: "M12 12h120v86H12z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#dbdbdb",
      strokeWidth: 11.75308228,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "markers stroke fill"
    },
    d: "M5.877 5.877h180.247v180.247H5.877z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopLeft);
export default __webpack_public_path__ + "static/media/topLeft.e8a66e4977ab58a2f99cff45acd7e17f.svg";
export { ForwardRef as ReactComponent };